export default __webpack_public_path__ + "static/media/CenterAlignIcon.af89a0b5.svg";